// extracted by mini-css-extract-plugin
export default {"stepContainer":"Exercise_stepContainer__uI9mT","stepCircle":"Exercise_stepCircle__Njxhd","active":"Exercise_active__a75mP"};